/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDimensionFlowerVariant = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.998 4c-.838 0-1.589.721-1.589 1.7v1.558A4.994 4.994 0 0 1 12 7c.555 0 1.088.09 1.587.257V5.7c0-.979-.75-1.7-1.589-1.7zm3.392 4.325a4.99 4.99 0 0 1 1.56 2.962l1.24-.747c.76-.458 1.051-1.51.588-2.347-.45-.814-1.41-1.058-2.146-.616l-1.242.748zm1.443 4.96a5.005 5.005 0 0 1-1.894 2.76l1.693 1.02c.735.443 1.695.199 2.146-.616.463-.837.173-1.888-.589-2.347l-1.356-.816zm-3.246 3.458A4.994 4.994 0 0 1 12 17c-.556 0-1.091-.09-1.59-.258V18.3c0 .979.75 1.7 1.588 1.7.838 0 1.59-.721 1.59-1.7v-1.557zm-4.526-.697a5.006 5.006 0 0 1-1.894-2.76l-1.356.816c-.762.459-1.052 1.51-.589 2.348.45.814 1.41 1.058 2.146.615l1.693-1.02zM8.41 5.7C8.41 3.697 9.977 2 12 2c2.02 0 3.588 1.697 3.588 3.7v.172l.013-.008c1.742-1.049 3.949-.408 4.928 1.36.966 1.746.408 3.997-1.307 5.03l-.112.067.112.068c1.715 1.033 2.273 3.284 1.307 5.03-.98 1.768-3.186 2.408-4.928 1.36l-.04-.025c-.216 1.8-1.695 3.246-3.562 3.246-1.865 0-3.345-1.445-3.561-3.244l-.037.023c-1.742 1.048-3.949.408-4.928-1.36-.966-1.747-.408-3.997 1.307-5.03l.112-.068-.112-.067C3.064 11.22 2.506 8.97 3.472 7.224c.98-1.768 3.186-2.409 4.928-1.36l.01.006V5.7zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDimensionFlowerVariant as DimensionFlowerVariant };
